class BlogCarousel extends HTMLElement {
  constructor() {
    super();
    this.initializeCarousel();
  }

  initializeCarousel() {
    this.scroller = this.querySelector('.scroller');
    this.progressBar = this.querySelector('progress');

    if (!this.scroller || !this.progressBar) {
      console.error('BlogCarousel: Required elements not found');
      return;
    }

    this.items = [...this.scroller.children];
    if (this.items.length === 0) {
      console.error('BlogCarousel: No items found');
      return;
    }

    this.controller = new AbortController();
    const { signal } = this.controller;

    // デバウンス処理を含むスクロールイベント
    const debouncedUpdate = this.debounce(this.updateCarouselState.bind(this));

    this.scroller.addEventListener('scroll', debouncedUpdate, { signal });
    window.addEventListener('resize', debouncedUpdate, { signal });

    // アクセシビリティ属性の設定
    this.setAttributes();
    
    // 初期状態の更新
    debouncedUpdate();
  }

  setAttributes() {
    this.setAttribute('aria-roledescription', 'カルーセル');

    this.items.forEach((item, index) => {
      item.setAttribute('role', 'group');
      item.setAttribute('aria-roledescription', 'スライド');
      item.setAttribute('aria-label', `${index + 1} of ${this.items.length}`);
    });
  }

  updateCarouselState() {
    if (!this.scroller || !this.progressBar) return;

    this.updateProgressBar();
    this.updateInertAttribute();
  }

  updateProgressBar() {
    if (!this.scroller || !this.progressBar) return;

    const scrollLeft = this.scroller.scrollLeft;
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    
    // スクロール不可能な場合は0%
    if (maxScroll <= 0) {
      this.progressBar.value = 0;
      return;
    }

    const scrollPercentage = (scrollLeft / maxScroll) * 100;
    const clampedPercentage = Math.min(Math.max(scrollPercentage, 0), 100);
    this.progressBar.style.setProperty('--progress-position', `${clampedPercentage}%`);
  }

  updateInertAttribute() {
    if (!this.scroller) return;

    const scrollerRect = this.scroller.getBoundingClientRect();

    this.items.forEach((item) => {
      const itemRect = item.getBoundingClientRect();
      const isVisible = 
        itemRect.left < scrollerRect.right && 
        itemRect.right > scrollerRect.left;
      
      // inert属性でスクリーンリーダーの対象外にする
      item.inert = !isVisible;
    });
  }

  debounce(callback) {
    let timeout;
    return (...args) => {
      if (timeout !== undefined) cancelAnimationFrame(timeout);
      timeout = requestAnimationFrame(() => callback.apply(this, args));
    };
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

// カスタム要素として登録
customElements.define('carousel-slider', BlogCarousel);